export default () => <div className="loading">Loading...</div>